module.exports = __webpack_public_path__ + "img/stock2.cf5a08ee.png";